var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-chip',{staticClass:"pa-0 ma-0 caption",attrs:{"dark":"","small":"","dense":"","color":_vm.color,"text-color":"white"}},[_vm._v(" "+_vm._s(_vm.$t('virtual-site.short.' + _vm.sitename).toUpperCase())+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }